// 模拟后端请求回来的路由
/*
路由规则：1.children下的首页必须是父级路由名称+page
*/
const menu = [
  {
    name: "",
    path: "",
    meta: ["培训任务"],
    component: { render: e => e("router-view") },
    children: [
      {
        path: "manage",
        name: "Manage",
        component: () => import("@/views/taskTraining/manage/index.vue"),
        meta: ["任务管理"]
      },
      {
        path: "situation",
        name: "Situation",
        component: () => import("@/views/taskTraining/situation/index.vue"),
        meta: ["培训情况"]
      }
    ]
  }
];

export default menu;
